// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2suqs","log":"ModalInventoryLogs_log__3U2PU","date":"ModalInventoryLogs_date__1dhN8","userName":"ModalInventoryLogs_userName__1B3Ao"};